<template>
  <div class="detail-setting-content">
    <div v-if="!type" class="empty">请选择要设置的内容</div>
    <template v-else>
      <div class="title">{{ title }}</div>
      <div ref="scrollWrapper" class="scroll-wrapper" v-ps>
        <control-setting
          v-if="type == 'field'"
          v-on="$listeners"
          ref="controlSetting"
          :control="control"
          :fields="fields"
          :sheet="sheet.data"
          :availableSheets="availableSheets.data"
          class="setting-box"
        ></control-setting>
        <button-array-setting
          v-else-if="type == 'btnArray'"
          v-on="$listeners"
          :btnArray="btnArray"
        ></button-array-setting>
        <overview-fields-setting
          v-else-if="type == 'overviewInfo'"
          v-on="$listeners"
          :fields="fields"
          :overviewFields="overviewFields"
        ></overview-fields-setting>
        <progress-setting
          v-else-if="type == 'progress'"
          v-on="$listeners"
          :progress="progress"
          :sheet="sheet"
        ></progress-setting>
      </div>
    </template>
  </div>
</template>

<script>
import ControlSetting from "./control-setting"
import ButtonArraySetting from "./button-array-setting"
import OverviewFieldsSetting from "./overview-fields-setting"
import ProgressSetting from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/progress-setting"
export default {
  name: "detail-setting-content",
  components: {
    ProgressSetting,
    ControlSetting,
    ButtonArraySetting,
    OverviewFieldsSetting
  },
  props: {
    type: String,
    sheet: Object,
    control: Object,
    controlsMap: Object,
    btnArray: Array,
    fields: Array,
    overviewFields: Array,
    progress: Object,
    availableSheets: Object
  },
  data() {
    return {
      // control: {}
    }
  },
  computed: {
    title() {
      if (this.type == "field") return `字段设置 - ${this.controlsMap[this.control._type].name}`
      else if (this.type == "overviewInfo") return "摘要"
      else if (this.type == "btnArray") return "按钮"
      else if (this.type == "progress") return "步骤条"
      else return "组件设置"
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.$children[0].init()
        this.$nextTick(() => this.$refs.scrollWrapper?._ps_.update())
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-setting-content {
  display: flex;
  flex-flow: column;
  height: 100%;
  background-color: #fafafa;
  padding: 18px 20px;
  position: relative;
  box-sizing: border-box;
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 100%;
    padding-bottom: 50px;
    font-size: 14px;
    color: #777;
  }
  .title {
    box-sizing: border-box;
    height: 55px;
    padding: 16px;
    background-color: #ebebeb;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
  }
  .scroll-wrapper {
    flex: auto;
    height: 0;
  }
}
</style>
